module.exports = __webpack_public_path__ + "static/media/technological-university.923a2c43.png";